import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row g-xl-2" }
const _hoisted_2 = { class: "col-xxl-6" }
const _hoisted_3 = { class: "card-body pt-5" }
const _hoisted_4 = { class: "row g-8 g-lg-8" }
const _hoisted_5 = { class: "col-4 p-2" }
const _hoisted_6 = { class: "bg-white bg-opacity-70 rounded-2 px-6 py-5" }
const _hoisted_7 = { class: "symbol symbol-30px me-5 mb-8" }
const _hoisted_8 = { class: "symbol-label" }
const _hoisted_9 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_10 = { class: "m-0" }
const _hoisted_11 = { class: "text-gray-700 fw-bolder d-block fs-2 lh-1 ls-n1 mb-1" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "fs-4 fw-bolder" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 fw-semibold fs-6" }, "Total", -1)
const _hoisted_14 = { class: "col-4 p-2" }
const _hoisted_15 = { class: "bg-white bg-opacity-70 rounded-2 px-6 py-5" }
const _hoisted_16 = { class: "symbol symbol-30px me-5 mb-8" }
const _hoisted_17 = { class: "symbol-label" }
const _hoisted_18 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_19 = { class: "m-0" }
const _hoisted_20 = { class: "text-gray-700 fw-bolder d-block fs-2 lh-1 ls-n1 mb-1" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 fw-semibold fs-6" }, "New", -1)
const _hoisted_22 = { class: "col-4 p-2" }
const _hoisted_23 = { class: "bg-white bg-opacity-70 rounded-2 px-6 py-5" }
const _hoisted_24 = { class: "symbol symbol-30px me-5 mb-8" }
const _hoisted_25 = { class: "symbol-label" }
const _hoisted_26 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_27 = { class: "m-0" }
const _hoisted_28 = { class: "text-gray-700 fw-bolder d-block fs-2 lh-1 ls-n1 mb-1" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 fw-semibold fs-6" }, "Responded", -1)
const _hoisted_30 = { class: "col-xxl-6" }
const _hoisted_31 = { class: "card-body pt-5" }
const _hoisted_32 = { class: "row g-8 g-lg-8" }
const _hoisted_33 = { class: "col-4 p-2" }
const _hoisted_34 = { class: "bg-white bg-opacity-70 rounded-2 px-6 py-5" }
const _hoisted_35 = { class: "symbol symbol-30px me-5 mb-8" }
const _hoisted_36 = { class: "symbol-label" }
const _hoisted_37 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_38 = { class: "m-0" }
const _hoisted_39 = { class: "text-gray-700 fw-bolder d-block fs-2 lh-1 ls-n1 mb-1" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 fw-semibold fs-6" }, "Sales", -1)
const _hoisted_41 = { class: "col-4 p-2" }
const _hoisted_42 = { class: "bg-white bg-opacity-70 rounded-2 px-6 py-5" }
const _hoisted_43 = /*#__PURE__*/_createStaticVNode("<div class=\"symbol symbol-30px me-5 mb-8\"><span class=\"symbol-label\"><span class=\"svg-icon svg-icon-1 svg-icon-primary\"><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20 19.725V18.725C20 18.125 19.6 17.725 19 17.725H5C4.4 17.725 4 18.125 4 18.725V19.725H3C2.4 19.725 2 20.125 2 20.725V21.725H22V20.725C22 20.125 21.6 19.725 21 19.725H20Z\" fill=\"currentColor\"></path><path opacity=\"0.3\" d=\"M22 6.725V7.725C22 8.325 21.6 8.725 21 8.725H18C18.6 8.725 19 9.125 19 9.725C19 10.325 18.6 10.725 18 10.725V15.725C18.6 15.725 19 16.125 19 16.725V17.725H15V16.725C15 16.125 15.4 15.725 16 15.725V10.725C15.4 10.725 15 10.325 15 9.725C15 9.125 15.4 8.725 16 8.725H13C13.6 8.725 14 9.125 14 9.725C14 10.325 13.6 10.725 13 10.725V15.725C13.6 15.725 14 16.125 14 16.725V17.725H10V16.725C10 16.125 10.4 15.725 11 15.725V10.725C10.4 10.725 10 10.325 10 9.725C10 9.125 10.4 8.725 11 8.725H8C8.6 8.725 9 9.125 9 9.725C9 10.325 8.6 10.725 8 10.725V15.725C8.6 15.725 9 16.125 9 16.725V17.725H5V16.725C5 16.125 5.4 15.725 6 15.725V10.725C5.4 10.725 5 10.325 5 9.725C5 9.125 5.4 8.725 6 8.725H3C2.4 8.725 2 8.325 2 7.725V6.725L11 2.225C11.6 1.925 12.4 1.925 13.1 2.225L22 6.725ZM12 3.725C11.2 3.725 10.5 4.425 10.5 5.225C10.5 6.025 11.2 6.725 12 6.725C12.8 6.725 13.5 6.025 13.5 5.225C13.5 4.425 12.8 3.725 12 3.725Z\" fill=\"currentColor\"></path></svg></span></span></div>", 1)
const _hoisted_44 = { class: "m-0" }
const _hoisted_45 = { class: "text-gray-700 fw-bolder d-block fs-2 lh-1 ls-n1 mb-1" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "fs-4 fw-bolder" }, "%", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 fw-semibold fs-6" }, "Ratio", -1)
const _hoisted_48 = { class: "col-4 p-2" }
const _hoisted_49 = { class: "bg-white bg-opacity-70 rounded-2 px-6 py-5" }
const _hoisted_50 = /*#__PURE__*/_createStaticVNode("<div class=\"symbol symbol-30px me-5 mb-8\"><span class=\"symbol-label\"><span class=\"svg-icon svg-icon-1 svg-icon-primary\"><svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14 18V16H10V18L9 20H15L14 18Z\" fill=\"currentColor\"></path><path opacity=\"0.3\" d=\"M20 4H17V3C17 2.4 16.6 2 16 2H8C7.4 2 7 2.4 7 3V4H4C3.4 4 3 4.4 3 5V9C3 11.2 4.8 13 7 13C8.2 14.2 8.8 14.8 10 16H14C15.2 14.8 15.8 14.2 17 13C19.2 13 21 11.2 21 9V5C21 4.4 20.6 4 20 4ZM5 9V6H7V11C5.9 11 5 10.1 5 9ZM19 9C19 10.1 18.1 11 17 11V6H19V9ZM17 21V22H7V21C7 20.4 7.4 20 8 20H16C16.6 20 17 20.4 17 21ZM10 9C9.4 9 9 8.6 9 8V5C9 4.4 9.4 4 10 4C10.6 4 11 4.4 11 5V8C11 8.6 10.6 9 10 9ZM10 13C9.4 13 9 12.6 9 12V11C9 10.4 9.4 10 10 10C10.6 10 11 10.4 11 11V12C11 12.6 10.6 13 10 13Z\" fill=\"currentColor\"></path></svg></span></span></div>", 1)
const _hoisted_51 = { class: "m-0" }
const _hoisted_52 = { class: "text-gray-700 fw-bolder d-block fs-2 lh-1 ls-n1 mb-1" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", { class: "fs-4 fw-bolder" }, "$", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 fw-semibold fs-6" }, "Recovered", -1)
const _hoisted_55 = { class: "col-md-6 g-4" }
const _hoisted_56 = { class: "col-12 card card-flush h-lg-100" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "card-header pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bold text-dark fs-5" }, "Card Brands"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 mt-1 fw-semibold fs-6" }, "Totals")
  ])
], -1)
const _hoisted_58 = { class: "card-body pt-2" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_60 = { class: "d-flex flex-stack" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-700 fw-semibold fs-6 me-2" }, "Visa", -1)
const _hoisted_62 = { class: "d-flex align-items-senter" }
const _hoisted_63 = { class: "text-gray-900 fw-bolder fs-6" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_65 = { class: "d-flex flex-stack" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-700 fw-semibold fs-6 me-2" }, "Mastercard", -1)
const _hoisted_67 = { class: "d-flex align-items-senter" }
const _hoisted_68 = { class: "text-gray-900 fw-bolder fs-6" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_70 = { class: "d-flex flex-stack" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-700 fw-semibold fs-6 me-2" }, "Discover", -1)
const _hoisted_72 = { class: "d-flex align-items-senter" }
const _hoisted_73 = { class: "text-gray-900 fw-bolder fs-6" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_75 = { class: "d-flex flex-stack" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-700 fw-semibold fs-6 me-2" }, " American Express ", -1)
const _hoisted_77 = { class: "d-flex align-items-senter" }
const _hoisted_78 = { class: "text-gray-900 fw-bolder fs-6" }
const _hoisted_79 = { class: "col-md-6 g-4" }
const _hoisted_80 = { class: "col-12 card card-flush h-lg-100" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("div", { class: "card-header pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bold text-dark fs-5" }, "Reason Category"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 mt-1 fw-semibold fs-6" }, "Totals")
  ])
], -1)
const _hoisted_82 = { class: "card-body pt-5" }
const _hoisted_83 = { class: "d-flex flex-stack" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-700 fw-semibold fs-6 me-2" }, "Fraud", -1)
const _hoisted_85 = { class: "d-flex align-items-senter" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 svg-icon-success me-2" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      opacity: "0.5",
      x: "16.9497",
      y: "8.46448",
      width: "13",
      height: "2",
      rx: "1",
      transform: "rotate(135 16.9497 8.46448)",
      fill: "currentColor"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M14.8284 9.97157L14.8284 15.8891C14.8284 16.4749 15.3033 16.9497 15.8891 16.9497C16.4749 16.9497 16.9497 16.4749 16.9497 15.8891L16.9497 8.05025C16.9497 7.49797 16.502 7.05025 15.9497 7.05025L8.11091 7.05025C7.52512 7.05025 7.05025 7.52513 7.05025 8.11091C7.05025 8.6967 7.52512 9.17157 8.11091 9.17157L14.0284 9.17157C14.4703 9.17157 14.8284 9.52975 14.8284 9.97157Z",
      fill: "currentColor"
    })
  ])
], -1)
const _hoisted_87 = { class: "text-gray-900 fw-bolder fs-6" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_89 = { class: "d-flex flex-stack" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-700 fw-semibold fs-6 me-2" }, " Processing Errors ", -1)
const _hoisted_91 = { class: "d-flex align-items-senter" }
const _hoisted_92 = { class: "text-gray-900 fw-bolder fs-6" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_94 = { class: "d-flex flex-stack" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-700 fw-semibold fs-6 me-2" }, " Consumer Dispute ", -1)
const _hoisted_96 = { class: "d-flex align-items-senter" }
const _hoisted_97 = { class: "text-gray-900 fw-bolder fs-6" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_99 = { class: "d-flex flex-stack" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-700 fw-semibold fs-6 me-2" }, "Authorization", -1)
const _hoisted_101 = { class: "d-flex align-items-senter" }
const _hoisted_102 = { class: "text-gray-900 fw-bolder fs-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen002.svg" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, [
                  _hoisted_12,
                  _createTextVNode(_toDisplayString(_ctx.overAllTotal), 1)
                ]),
                _hoisted_13
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, [
                  _createElementVNode("span", _hoisted_18, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen029.svg" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.incomingOverview.notsent_count), 1),
                _hoisted_21
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("span", _hoisted_25, [
                  _createElementVNode("span", _hoisted_26, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr028.svg" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.incomingOverview.sent_count), 1),
                _hoisted_29
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("span", _hoisted_36, [
                  _createElementVNode("span", _hoisted_37, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen026.svg" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.totalSales), 1),
                _hoisted_40
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("span", _hoisted_45, [
                  _createTextVNode(_toDisplayString(_ctx.cbratio), 1),
                  _hoisted_46
                ]),
                _hoisted_47
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _hoisted_50,
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("span", _hoisted_52, [
                  _hoisted_53,
                  _createTextVNode(_toDisplayString(_ctx.recovered), 1)
                ]),
                _hoisted_54
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_55, [
      _createElementVNode("div", _hoisted_56, [
        _hoisted_57,
        _createElementVNode("div", _hoisted_58, [
          _hoisted_59,
          _createElementVNode("div", _hoisted_60, [
            _hoisted_61,
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.visaTotal), 1)
            ])
          ]),
          _hoisted_64,
          _createElementVNode("div", _hoisted_65, [
            _hoisted_66,
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.mastercardTotal), 1)
            ])
          ]),
          _hoisted_69,
          _createElementVNode("div", _hoisted_70, [
            _hoisted_71,
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.discoverTotal), 1)
            ])
          ]),
          _hoisted_74,
          _createElementVNode("div", _hoisted_75, [
            _hoisted_76,
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.amexTotal), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_79, [
      _createElementVNode("div", _hoisted_80, [
        _hoisted_81,
        _createElementVNode("div", _hoisted_82, [
          _createElementVNode("div", _hoisted_83, [
            _hoisted_84,
            _createElementVNode("div", _hoisted_85, [
              _hoisted_86,
              _createElementVNode("span", _hoisted_87, _toDisplayString(_ctx.totalFraudChargebacks), 1)
            ])
          ]),
          _hoisted_88,
          _createElementVNode("div", _hoisted_89, [
            _hoisted_90,
            _createElementVNode("div", _hoisted_91, [
              _createElementVNode("span", _hoisted_92, _toDisplayString(_ctx.totalProcessingChargebacks), 1)
            ])
          ]),
          _hoisted_93,
          _createElementVNode("div", _hoisted_94, [
            _hoisted_95,
            _createElementVNode("div", _hoisted_96, [
              _createElementVNode("span", _hoisted_97, _toDisplayString(_ctx.totalConsumerChargebacks), 1)
            ])
          ]),
          _hoisted_98,
          _createElementVNode("div", _hoisted_99, [
            _hoisted_100,
            _createElementVNode("div", _hoisted_101, [
              _createElementVNode("span", _hoisted_102, _toDisplayString(_ctx.totalAuthorizationChargebacks), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}